<div class="fixed inset-0 z-50 grid place-items-center bg-black/50 backdrop-blur-sm p-4">
  <div class="w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-2xl border border-border-color bg-white shadow-[0_12px_36px_var(--box-shadow-color)]">
    <header class="flex items-center justify-between bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-5 py-3 text-light-color">
      <div class="flex items-center gap-3">
        <i class="fa-regular fa-calendar-plus text-lg"></i>
        <h2 class="text-base font-semibold">Remarcar Agendamento</h2>
      </div>
      <button
        type="button"
        class="flex h-9 w-9 items-center justify-center rounded-full border border-white/30 bg-white/10 text-white transition hover:bg-white/20"
        (click)="handleCloseModal()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </header>

    <div class="px-5 py-5">
      <form class="space-y-4" id="appointment-form">
        <div class="space-y-2">
          <h3 class="text-sm font-semibold text-dark-color">Data do Agendamento</h3>
          <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
            <div>
              <label for="date" class="mb-1 block text-sm text-dark-color/80">Data</label>
              <input
                name="date"
                type="date"
                id="date"
                class="w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
                [(ngModel)]="dateForm"
                (change)="handleShowDate()" />
            </div>
            <ng-container *ngIf="dateAppointment">
              <div>
                <ng-container *ngIf="avaliableTimes; else semHorario">
                  <label for="startTime" class="mb-1 block text-sm text-dark-color/80">Horários Disponíveis</label>
                  <select
                    name="startTime"
                    id="startTime"
                    class="w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
                    [(ngModel)]="copyObjectRefAppointment.startTime">
                    <option *ngFor="let time of avaliableTimes" [value]="time">{{ time }}</option>
                  </select>
                </ng-container>
                <ng-template #semHorario>
                  <p class="text-sm font-semibold text-red-600">Sem horário disponível na data selecionada</p>
                </ng-template>
              </div>
            </ng-container>
          </div>
        </div>

        <ng-container *ngIf="dateAppointment">
          <div class="space-y-2">
            <h3 class="text-sm font-semibold text-dark-color">Dados do Cliente</h3>
            <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
              <label class="block text-sm text-dark-color">
                Nome
                <input
                  name="clientName"
                  type="text"
                  id="clientName"
                  class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
                  [(ngModel)]="copyObjectRefAppointment.clientName"
                  [value]="copyObjectRefAppointment.clientName" />
              </label>
              <label class="block text-sm text-dark-color">
                Telefone
                <input
                  name="clientPhone"
                  type="tel"
                  id="clientPhone"
                  mask="(00) 00000-0000"
                  class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
                  [(ngModel)]="copyObjectRefAppointment.clientPhone"
                  [value]="copyObjectRefAppointment.clientPhone" />
              </label>
              <label class="md:col-span-2 block text-sm text-dark-color">
                Documento
                <input
                  type="text"
                  id="clientDocument"
                  name="clientDocument"
                  placeholder="CPF/CNPJ"
                  class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
                  [(ngModel)]="copyObjectRefAppointment.clientDocument"
                  [value]="copyObjectRefAppointment.clientDocument" />
              </label>
            </div>
          </div>

          <div class="space-y-2">
            <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
              <label class="block text-sm text-dark-color">
                Origem
                <select
                  name="origin"
                  id="origin"
                  class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
                  [(ngModel)]="copyObjectRefAppointment.origin">
                  <option [value]="copyObjectRefAppointment.origin" selected>{{ copyObjectRefAppointment.origin }}</option>
                  <option value="Whatsapp">Whatsapp</option>
                  <option value="Telefone">Telefone</option>
                  <option value="Instagram">Instagram</option>
                  <option value="Email">Email</option>
                  <option value="Facebook">Facebook</option>
                  <option value="Outro">Outro</option>
                </select>
              </label>

              <label class="block text-sm text-dark-color">
                Status
                <select
                  name="status"
                  id="status"
                  class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
                  [value]="copyObjectRefAppointment.status"
                  [(ngModel)]="copyObjectRefAppointment.status">
                  <option [value]="copyObjectRefAppointment.status" selected>{{ getStatusEnum(copyObjectRefAppointment.status) }}</option>
                  <option value="scheduled">Agendado</option>
                  <option value="pending">Pendente</option>
                  <option value="canceled">Cancelado</option>
                  <option value="confirmed">Confirmado</option>
                </select>
              </label>
            </div>

            <label class="block text-sm text-dark-color">
              Observações
              <textarea
                name="notes"
                id="notes"
                rows="2"
                class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
                [value]="copyObjectRefAppointment?.notes"
                [(ngModel)]="copyObjectRefAppointment.notes"></textarea>
            </label>
          </div>
        </ng-container>

        <div class="flex flex-col gap-2 border-t border-border-color pt-3 md:flex-row md:justify-end">
          <button
            type="button"
            class="inline-flex items-center justify-center gap-2 rounded-base border border-border-color bg-white px-4 py-2 text-sm font-semibold text-dark-color shadow-sm transition hover:border-primary-color"
            (click)="handleCloseModal()">
            <i class="fa-solid fa-xmark"></i>
            Cancelar
          </button>
          <button
            type="button"
            class="inline-flex items-center justify-center gap-2 rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover"
            (click)="handleSubmitReeschedule()">
            <i class="fa-solid fa-check"></i>
            Salvar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<app-loading-modal></app-loading-modal>
<app-alert></app-alert>
